// @ts-check
import { useActions, useGetters } from 'vuex-composition-helpers/dist'

export function useOtp () {
  const { otpStatus } = useGetters({
    otpStatus: 'auth/otpStatus'
  })

  const { sendOtp, verifyOtp } = useActions({
    sendOtp: 'auth/sendOtp',
    verifyOtp: 'auth/verifyOtp'
  })

  return {
    otpStatus,
    sendOtp,
    verifyOtp
  }
}
